import React, { useState, useEffect, useMemo } from "react";
import { Row, Col, Button, FormControl, Table, Spinner, Form } from "react-bootstrap";
import { useTable, usePagination, useGlobalFilter, useSortBy } from "react-table";
import { API_WEB_URLS } from "../../constants/constAPI";
import { useDispatch } from "react-redux";
import { Fn_FillListData, Fn_GetReport } from "../../store/Functions";
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Select from "react-select";

const PageList_Result = () => {
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedValue, setSelectedValue] = useState(null);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const breadCrumbTitle = "Test Master";
  const breadcrumbItem = "Test Master";
  const API_URL_SAVE = `GetResults/0/token`;
  const API_URL = `${API_WEB_URLS.MASTER}/0/token/McqMasterFill`;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      Fn_FillListData(dispatch, setDropdownOptions, "dropdownOptions", API_URL + "/Id/0");
      setLoading(false);
    };

    fetchData();
  }, [dispatch, API_URL]);

  const btnAddOnClick = () => {
    // navigate(rtPage_Add, { state: { Id: 0 } });
  };

  const btnEditOnClick = Id => {
    // navigate(rtPage_Edit, { state: { Id } });
  };

  const btnDeleteOnClick = formData => {
    // Delete item logic
  };

  const handleDropdownSubmit = () => {
    if (selectedValue) {
      const formData = new FormData();
      formData.append("F_McqMasterH", selectedValue.value);

      Fn_GetReport(
        dispatch,
        setGridData,
        "gridData",
        API_URL_SAVE,
        { arguList: { id: 0, formData: formData } },
        true
      );
    }
  };

  const data = useMemo(() => gridData || [], [gridData]);

  const columns = useMemo(
    () => [
      {
        Header: "TestName",
        accessor: "TestName",
      },
      {
        Header: "Name",
        accessor: "Name",
      },
      {
        Header: "MarksScored",
        accessor: "MarksScored",
      },
      {
        Header: "FailOrNot",
        accessor: "FailOrNot",
      },
      {
        Header: "View",
        Cell: ({ row }) => (
          <Button
            variant="danger"
            size="sm"
            onClick={() => btnEditOnClick(row.original.Id)}
          >
            View
          </Button>
        ),
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize, globalFilter },
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  // Inline styles for the table
  const tableStyles = {
    borderCollapse: 'collapse',
  };

  const headerStyles = {
    border: '2px solid #333', // Darken the border color
    backgroundColor: 'rgba(135, 206, 235, 0.5)'// Light background color for headers
  };

  const cellStyles = {
    border: '2px solid #333', // Darken the border color
  };

  return (
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumbs title={breadCrumbTitle} breadcrumbItem={breadcrumbItem} />

        <Row className="mb-2">
          <Col md="4">
            <Form.Group controlId="dropdownControl">
              <Select
                value={selectedValue}
                onChange={setSelectedValue}
                options={dropdownOptions}
                placeholder="Select an option"
                isSearchable={true}
              />
            </Form.Group>
          </Col>
          <Col md="2">
            <Button
              type="button"
              onClick={handleDropdownSubmit}
              variant="primary"
              className="mb-2"
              disabled={!selectedValue}
            >
              Submit
            </Button>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col md="4">
            <FormControl
              type="text"
              placeholder="Search"
              value={globalFilter || ""}
              onChange={e => setGlobalFilter(e.target.value)}
              className="mb-2"
            />
          </Col>
          {/* <Col md="4">
            <Button
              type="button"
              onClick={btnAddOnClick}
              variant="success"
              className="mb-2"
            >
              Add New
            </Button>
          </Col> */}
        </Row>

        <Table {...getTableProps()} responsive bordered striped style={tableStyles}>
          <thead>
            {headerGroups.map(headerGroup => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th
                    key={column.id}
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    style={headerStyles}
                  >
                    {column.render("Header")}
                    <span>
                      {column.isSorted  
                        ? column.isSortedDesc
                          ? " 🔽"
                          : " 🔼"
                        : ""}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.length > 0 ? (
              page.map(row => {
                prepareRow(row);
                return (
                  <tr key={row.id} {...row.getRowProps()}>
                    {row.cells.map(cell => (
                      <td key={cell.column.id} {...cell.getCellProps()} style={cellStyles}>
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={columns.length} className="text-center">
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        <Row className="mt-2">
          <Col>
            <Button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
              {"<<"}
            </Button>{" "}
            <Button onClick={() => previousPage()} disabled={!canPreviousPage}>
              {"<"}
            </Button>{" "}
            <Button onClick={() => nextPage()} disabled={!canNextPage}>
              {">"}
            </Button>{" "}
            <Button
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            >
              {">>"}
            </Button>{" "}
            <span>
              Page{" "}
              <strong>
                {pageIndex + 1} of {pageOptions.length}
              </strong>{" "}
            </span>
            <span>
              | Go to page:{" "}
              <input
                type="number"
                defaultValue={pageIndex + 1}
                onChange={e => {
                  const page = e.target.value ? Number(e.target.value) - 1 : 0;
                  gotoPage(page);
                }}
                style={{ width: "100px" }}
              />
            </span>{" "}
            <select
              value={pageSize}
              onChange={e => {
                setPageSize(Number(e.target.value));
              }}
            >
              {[10, 20, 30, 40, 50].map(pageSize => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PageList_Result;
